<template>
  <div>
    <s-card :border="false" :padding="false" class="flex-grow container pr-0">
      <div class="three-column-grid">
        <div class="flex justify-center">
          <s-avatar/>
        </div>
        <div class="flex flex-column">
          <span class="title-label">Jane H.</span>
          <span class="value-label">Hi Asif, your shipment has been cleared by customs at the origin port, we will notify you once it is departed</span>
        </div>
        <div class="flex flex-column">
          <span class="title-label color-dim">12:00 PM</span>
        </div>
      </div>
    </s-card>
  </div>
</template>

<script>
import SButton from "./SButton";
import SCard from "./SCard";
import SAvatar from "./SAvatar";

export default {
name: "SPillSeparator",
  components:{
    SAvatar,
    SButton,
    SCard,
  },
  props: {
    value: {},
  },
  data: function (){
    return {
      inputFocused: false,
    }
  },
  methods: {
    attachmentClicked(){

    },
    handleInput: function (event) {
      this.$emit("input", event.target.value);
    },
    onInputFocus(){
      this.inputFocused = true;
      this.$emit('focus-change',true);
    },
    onInputBlur(){
      this.inputFocused = false;
      this.$emit('focus-change',false);
    },
    sendMessage(){
      this.$emit('send-message',this.value);
    }
  }
}
</script>

<style scoped lang="scss">


.flex-grow{
  flex-grow: 1;
  align-self: stretch;
}

.message-box {
  height: 57px !important;
  display: flex;
}

.container {
  height: 100%;
  width: 100%;
}

.flex {
  display: flex;
  flex: 1;
}
.flex-column {
  flex-direction: column;
}
.flex-row {
  flex-direction: row;
}

.justify-center {
  justify-content: center;
}
.content-stretch {
  align-content: stretch;
}
.content-center {
  align-content: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.items-center {
  align-items: center;
}
.text-bold{
  font-weight: bold;
}

.width-100{
  width: 100%;
}
.height-100{
  height: 100%;
}
.font-14{
  font-size: 16px;
}

.no-resize {
  resize: none;
}

.pb-16 {
  padding-bottom: 16px;
}
.pb-24 {
  padding-bottom: 24px;
}
.pr-12 {
  padding-right:12px;
}
.p-8{
  padding: 8px;
}
.pr-0{
  padding-right:0;
}

.p-12 {
  padding: 18px;
}
.pl-64{
  padding-left: 64px;
}

.pl-64{
  padding-left: 64px;
}

.three-column-grid {
  display: grid;
  grid-template-columns: 0.5fr 8fr 100px;
  grid-column-gap: 30px;
  grid-row-gap: 20px;
}



</style>